import styled from 'react-emotion';
import { withTheme } from 'emotion-theming';

export const CompanyPageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const ErrorMessage = styled.span`
  color: #f85359;
  font-size: 14px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 38px 0 40px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmailContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 424px;
  height: 73px;
  margin-right: 44px;
`;

export const SelectContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 73px;
  width: 170px;
`;

export const ContactEmail = withTheme(styled.a`
  ${({ theme: { color } }) => `
    line-height: 23px;
    color: ${color.black3};
    text-decoration: none;
    :hover {
      text-decoration: underline;
      color: ${color.black3};
    }
  `}
`);

export const FlexContainer = styled.div`
  display: flex;
  margin-bottom: 38px;
`;

export const Heading = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black1};
    font-size: 24px;
    line-height: 31px;
    margin-bottom: 64px;
    text-transform: uppercase;
    font-weight: 500
  `}
`);

export const LabelText = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black2};
    display: flex;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    margin-bottom: 13px
  `}
`);

export const SendEmailText = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black2};
    display: flex;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    justify-content: center;
    margin: 36px 0 10px;
  `}
`);
